<template>
  <div class="sample-detail" id="sampleDetail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toOrderList">购样单/</span>购样单详情
        <!-- {{ pageModule ? "购样单编辑" : "购样单详情" }} -->
      </template>
      <template v-slot:content>
        <div class="radios-container">
          <el-radio-group v-model="infoType">
            <el-radio-button :label="infoTypes.orderInfo"
              >购样单信息</el-radio-button
            >
          </el-radio-group>
        </div>
        <!-- 订单信息 -->
        <div class="base-content" ref="baseContent"></div>
        <div class="order-information" v-show="isShowOrderInfo">
          <div class="customer-related">
            <div class="top">
              <div class="left">
                <div class="left-row">
                  <div class="container">
                    <span class="desc">客户名称：</span>
                    <span class="content">{{ customInfo.name }}</span>
                  </div>
                  <div class="container">
                    <span class="desc">所在地区：</span>
                    <span class="content" v-if="customInfo.area">{{
                      customInfo.area
                    }}</span>
                    <span class="content" v-else>无</span>
                  </div>
                </div>
                <div class="left-row">
                  <div class="container">
                    <span class="desc">联系人：</span>
                    <span class="content">{{ customInfo.contact }}</span>
                  </div>
                  <div class="container">
                    <span class="desc">联系方式：</span>
                    <span class="content">{{ customInfo.telephone }}</span>
                  </div>
                </div>
                <div class="left-row">
                  <div class="container">
                    <span class="desc">支付状态：</span>
                    <span class="content">{{
                      customInfo.payStatus === 1
                        ? "已支付"
                        : customInfo.payStatus === 0
                        ? "未支付"
                        : "已关闭"
                    }}</span>
                  </div>
                  <div class="container">
                    <span class="desc">支付方式：</span>
                    <span class="content">{{ customInfo.payMethodDesc }}</span>
                  </div>
                </div>
              </div>
              <div class="right">
                当前订单状态:
                <span class="order-status">{{ currOrderDesc }}</span>
              </div>
            </div>
            <div class="bottom">
              <div class="container">
                <span class="desc">买家留言：</span>
                <span class="content">{{ customInfo.message }}</span>
              </div>
              <div class="container fullAddress">
                <span class="desc">收货地址：</span>
                <span class="content">{{ receiptInfo.addressInfo }}</span>
              </div>
            </div>
          </div>
          <div class="order-detail-related">
            <div class="table-img">
              <el-table class="table-container" :data="orderDetail">
                <el-table-column label="商品名称" width="400">
                  <template slot-scope="props">
                    <img
                      class="img"
                      width="20"
                      height="20"
                      :src="props.row.commodityImg"
                      alt
                    />
                    <p class="name" :title="props.row.commodityName">
                      {{ props.row.commodityName }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  label="规格"
                  prop="norm"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="数量"
                  prop="amount"
                  class="amount-column"
                  align="center"
                >
                  <template slot-scope="props">
                    <span
                      class="column-amount"
                      v-show="isViewModule || isMeal"
                      >{{ props.row.amount }}</span
                    >
                    <int-input
                      class="amount-input"
                      v-show="isEditModule && !isMeal"
                      :updateIndex="props.$index"
                      :intNum="Number(props.row.amount)"
                      @update="onUpdateAmount"
                      @complete="filterAmountNum"
                    ></int-input>
                  </template>
                </el-table-column>
                <el-table-column label="单价" prop="unitPrice" align="center">
                  <template slot-scope="props">
                    <span
                      class="column-amount"
                      v-show="isViewModule || isMeal"
                      >{{ props.row.unitPrice }}</span
                    >
                    <decimal-input
                      v-show="isEditModule && !isMeal"
                      class="amount-input"
                      :updateIndex="props.$index"
                      :decimalNum="props.row.unitPrice"
                      @update="onUpdateUnitPrice"
                      @complete="filterUnitPrice"
                    ></decimal-input>
                  </template>
                </el-table-column>
                <el-table-column label="小计" prop="subtotal" align="center">
                  <template slot-scope="props">
                    <p v-show="isViewModule">
                      <span
                        :class="
                          props.row.promotionReduce > 0
                            ? 'column-subtotal scribing'
                            : 'column-subtotal'
                        "
                        >{{ props.row.subtotal }}</span
                      >
                      <span
                        class="column-subtotal"
                        v-if="props.row.promotionReduce > 0"
                        >{{
                          props.row.subtotal - props.row.promotionReduce
                        }}</span
                      >
                    </p>
                    <el-input
                      v-show="isEditModule"
                      class="gray"
                      v-model.number="props.row.subtotal"
                      :disabled="true"
                    ></el-input>
                    <span
                      class="delete-btn"
                      v-show="isEditModule && props.row.isTemp"
                      @click="delTableTemporary(props.$index, props.row.id)"
                      >删除</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="temporary-container">
              <div
                class="temporary-item"
                v-for="(value, index) in temporaryData"
                :key="index"
              >
                <div class="temporary-name">
                  <el-input class="gray" v-model="value.goodsName"></el-input>
                </div>
                <div class="temporary-spec">
                  <el-input class="gray" v-model="value.itemTitle"></el-input>
                </div>
                <div class="temporary-num">
                  <int-input
                    class="good-amount"
                    :updateIndex="index"
                    :intNum="Number(value.quantity)"
                    @update="onUpdateTemporary"
                    @complete="filterTemporary"
                  ></int-input>
                </div>
                <div class="temporary-price">
                  <decimal-input
                    class="discount-input"
                    :decimalNum="value.unitPrice"
                    @complete="filterTemporaryUnitPrice($event, index)"
                  ></decimal-input>
                </div>
                <div class="temporary-total">
                  <el-input
                    class="gray"
                    disabled
                    :value="Number(value.unitPrice) * Number(value.quantity)"
                  ></el-input>
                  <span class="delete-btn" @click="delTemporary(index)"
                    >删除</span
                  >
                </div>
              </div>
            </div>
            <div class="subtotal" v-show="isViewModule">
              <div class="detail">
                <div class="order-total">
                  <span class="desc" v-if="isMeal">套餐合计</span>
                  <span class="desc" v-else>商品合计</span>
                  ：{{ paymentInfo.orderTotal + temporaryTotal }}
                </div>
                <div class="order-freight">
                  <span class="desc">+运费</span>
                  ：{{ paymentInfo.freight }}
                </div>
                <div class="order-discount">
                  <span class="desc">-商家优惠</span>
                  ：{{ paymentInfo.discount }}
                </div>
                <div class="order-couponPrice">
                  <span class="desc">-优惠劵</span>
                  ：{{ paymentInfo.couponPrice }}
                </div>
                <div class="order-promotionPrice">
                  <span class="desc">-促销</span>
                  ：{{ paymentInfo.promotionPrice }}
                </div>
              </div>
              <span class="amounts-payable">
                应付金额：
                <span class="need-to-pay-amount"
                  >￥{{ paymentInfo.needToPay }}</span
                >
              </span>
            </div>
            <div class="subtotal-edit" v-show="isEditModule">
              <div class="detail">
                <div class="order-total">
                  <span class="desc" v-if="isMeal">套餐合计：</span>
                  <span class="desc" v-else>商品合计：</span>
                  <!-- <el-input v-if="isMeal" class="gray" v-model.number="paymentInfo.orderTotal"></el-input>
                  <el-input
                    v-else
                    class="gray"
                    v-model.number="paymentInfo.orderTotal"
                    :disabled="true"
                  ></el-input>-->
                  <decimal-input
                    v-if="isMeal"
                    class="orderTotal-input"
                    :decimalNum="paymentInfo.orderTotal"
                    @complete="filterOrderTotal"
                  ></decimal-input>
                  <el-input
                    v-else
                    class="gray orderTotal-input"
                    :value="paymentInfo.orderTotal + temporaryTotal"
                    :disabled="true"
                  ></el-input>
                </div>
                <div class="order-freight">
                  <span class="desc">+运费：</span>
                  <decimal-input
                    class="freight-input"
                    :decimalNum="paymentInfo.freight"
                    @complete="filterFreightNum"
                  ></decimal-input>
                </div>
                <div class="order-discount">
                  <span class="desc">-商家优惠：</span>
                  <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.discount"
                    @complete="filterDiscountNum"
                  ></decimal-input>
                </div>
                <div class="order-discount">
                  <span class="desc">-优惠劵：</span>
                  <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.couponPrice"
                    @complete="filterCouponPriceNum"
                  ></decimal-input>
                </div>
                <div class="order-discount">
                  <span class="desc">-促销：</span>
                  <decimal-input
                    class="discount-input"
                    :decimalNum="paymentInfo.promotionPrice"
                    @complete="filterPromotionPriceNum"
                  ></decimal-input>
                </div>
              </div>
              <div class="amounts-payable">
                <span class="desc">应付金额：￥</span>
                <el-input
                  class="gray"
                  v-model="paymentInfo.needToPay"
                  :disabled="true"
                ></el-input>
              </div>
            </div>
            <div
              class="add-commodity-btn"
              v-show="isEditModule && moduleTempGoods"
            >
              <span class="add-btn" @click="addTemporary">添加临时商品</span>
            </div>
          </div>
          <div class="pay-detail-related">
            <div class="container">
              <span class="desc">订单号：</span>
              <span class="content">{{ orderInfo.orderNum }}</span>
            </div>
            <div class="container" v-show="!!orderInfo.paymentNum">
              <span class="desc">支付流水号：</span>
              <span class="content">{{ orderInfo.paymentNum }}</span>
            </div>
            <div class="container">
              <span class="desc">下单时间：</span>
              <span class="content">{{ orderInfo.createOrderTime }}</span>
            </div>
            <div class="container" v-show="!!orderInfo.completePayTime">
              <span class="desc">付款时间：</span>
              <span class="content">{{ orderInfo.completePayTime }}</span>
            </div>
            <div class="container" v-show="!!orderInfo.completeOrderTime">
              <span class="desc">完成时间：</span>
              <span class="content">{{ orderInfo.completeOrderTime }}</span>
            </div>
            <!-- 线下凭证 -->
            <div
              class="offline-payment-info"
              v-show="customInfo.payStatus && customInfo.payMethod === 1"
            >
              <div class="view-voucher container">
                <span class="btn-desc">交易凭证：</span>
                <span class="btn" @click="viewVoucher">查看大图</span>
              </div>
              <div class="view-remark container">
                <span class="btn-desc">备注：</span>
                <div class="remark">{{ paymentInfo.message }}</div>
              </div>
            </div>
            <div class="container container-remark">
              <span class="desc">商家备注：</span>
              <p class="content" v-show="isViewModule">
                <span v-if="orderInfo.dbMessage">{{
                  orderInfo.dbMessage
                }}</span>
                <span v-else>暂无</span>
              </p>
              <p class="textarea">
                <el-input
                  type="textarea"
                  v-model="orderInfo.dbMessage"
                  :rows="3"
                  placeholder="请输入商家备注"
                  v-show="isEditModule"
                ></el-input>
              </p>
            </div>
          </div>
        </div>
        <div class="operations" ref="operations">
          <div class="btns" v-show="isViewModule">
            <!-- <el-button class="btn-white printer" icon="el-icon-printer" @click="openPrinterDialog"></el-button> -->
            <el-button class="btn-white" @click="toOrderList">返回</el-button>
            <!-- <el-button
              v-show="isShowViewFooterOperation"
              class="btn-blue"
              @click="toUpdateOrder"
            >修改订单</el-button> -->
          </div>
          <div class="btns-edit" v-show="isEditModule">
            <el-button class="btn-white" @click="cancelUpdate">取消</el-button>
            <el-button class="btn-blue" @click="updateOrder">保存</el-button>
          </div>
        </div>
        <!-- 凭证轮播图 -->
        <div class="cover" v-show="showVoucher">
          <div class="close-btn-container">
            <div class="close-btn" @click="closeVoucher">X</div>
          </div>
          <div class="carousel-container">
            <div class="viewport">
              <ul class="carousel-list" ref="carouselList">
                <li
                  class="carousel-item"
                  v-for="(item, index) in voucherList"
                  :key="index"
                >
                  <img class="voucher-img" :src="item" alt="凭证" />
                </li>
              </ul>
            </div>
            <div class="prev-btn" @click="prevVoucher"></div>
            <div class="next-btn" @click="nextVoucher"></div>
          </div>
          <div class="tip">{{ tip }}</div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import IntInput from "components/base/IntInput";
import DecimalInput from "components/base/DecimalInput";
import {
  getDBUserRealName,
  getSupplierBasicInformation,
} from "common/js/storage";
import { orderStatusToDesc, formaTimeToSecond } from "common/js/util.js";
import DBOrder from "models/db/order.js";
import DBAddress from "models/db/address.js";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
const dbOrder = new DBOrder();
const dbAddress = new DBAddress();
const defaultGoodPic = "http://image.8844it.com/ydb2/goodDefault.png";
const pageModules = {
  viewModule: 1,
  editModule: 2,
};
const infoTypes = {
  orderInfo: 1,
  shipmentInfo: 2,
};
const payMethodMap = {
  0: "无",
  1: "线下付款",
  2: "支付宝",
  4: "农行支付",
};
// 待付款状态
const WAIT_PAY = 0;
// 待订单审核状态
const WAIT_CHECK_ORDER = 1;
// 待出库审核状态
const WAIT_CHECK_OUT = 5;
// 待发货状态
const WAIT_SHIP = 7;
export default {
  data() {
    return {
      isMeal: false, //是否为套餐
      setMealId: 0, //套餐id
      showShipDialog: false,
      selectedLogis: "",
      waybillCode: "",
      logisList: [],
      // 以上为发货信息相关
      infoTypes,
      orderCode: 0,
      pageModule: pageModules.viewModule,
      infoType: infoTypes.orderInfo,
      currOrderStatus: "",
      currOrderDesc: "",
      customInfo: {
        name: "",
        area: "",
        contact: "",
        telephone: "",
        payMethod: "",
        payMethodDesc: "",
        payStatus: "",
        message: "",
      },
      orderDetail: [],
      paymentInfo: {
        orderTotal: 0, // 商品合计
        temporaryTotal: 0, //临时商品合计
        freight: 0, // 运费
        promotionPrice: 0, // 促销减价
        couponPrice: 0, // 优惠劵
        discount: 0, // 商家优惠
        needToPay: 0, // 实际支付
        message: "",
      },
      orderInfo: {
        orderNum: "",
        paymentNum: "",
        createOrderTime: "",
        completePayTime: "",
        completeOrderTime: "",
        dbMessage: "",
      },
      expressInfo: {
        waybillCode: "",
        express: "",
      },
      outStoreRecordList: [],
      // 物流--收货信息
      receiptInfo: {
        receiver: "",
        telephone: "",
        fullAddress: "",
        address: "",
        // 已选择的地址 [省id, 市id, 区id]
        proCityDisIdArr: [],
        deliveryAddress: "",
        addressInfo: '' //收货信息
      },
      showLogisInfo: false,
      addressList: [],
      cascaderProps: {
        value: "id",
        label: "name",
      },
      // 凭证相关
      showVoucher: false,
      voucherList: [],
      // 当前展示的是第几张凭证
      currVoucherIndex: 0,
      domain: "",
      LogisDetail: "", // 物流信息
      dialogVisible: false, // 物流弹窗
      moduleStorage: "", // 仓库是否开启
      printerDialog: false, //打印弹窗
      nowDate: "",
      userRealName: "",
      updateCommodityIndex: "",
      //临时商品数据
      moduleTempGoods: false,
      temporaryData: [],
      updateTemporaryIndex: "",
      delTemporaryIds: [],
    };
  },
  computed: {
    tip() {
      return `${this.currVoucherIndex + 1}/${this.voucherList.length}页`;
    },
    maxVouncherIndex() {
      return this.voucherList.length - 1;
    },
    isViewModule() {
      return this.pageModule === pageModules.viewModule;
    },
    isEditModule() {
      return this.pageModule === pageModules.editModule;
    },
    isShowOrderInfo() {
      return this.infoType === infoTypes.orderInfo;
    },
    isShowExpress() {
      return !!this.expressInfo.express;
    },
    isShowShipmentInfo() {
      return this.infoType === infoTypes.shipmentInfo;
    },
    isShowViewFooterOperation() {
      return (
        (this.currOrderStatus === WAIT_PAY &&
          this.pageModule === pageModules.viewModule) ||
        (this.currOrderStatus === WAIT_CHECK_ORDER &&
          this.pageModule === pageModules.viewModule &&
          this.customInfo.payStatus === 0)
      );
    },
    isShowEditFooterOperation() {
      return (
        this.currOrderStatus === WAIT_PAY &&
        this.pageModule === pageModules.editModule
      );
    },
    isShowOutOfStoreBtn() {
      return this.currOrderStatus === WAIT_CHECK_OUT;
    },
    isShowShipBtn() {
      return this.currOrderStatus === WAIT_SHIP;
    },
    outStoreRecordIsEmpty() {
      return this.expressInfo.waybillCode || this.outStoreRecordList.length > 0;
    },
    //临时商品合计
    temporaryTotal() {
      let total = 0;
      this.temporaryData.map((item) => {
        total += Number(item.unitPrice) * Number(item.quantity);
      });
      this.paymentInfo.temporaryTotal = total;
      return total;
    },
  },
  watch: {
    showShipDialog: {
      handler(newVal) {
        if (!newVal) {
          this.selectedLogis = "";
          this.waybillCode = "";
        }
      },
    },
    orderDetail: {
      deep: true,
      handler(newValue) {
        if (!this.isMeal) {
          let total = 0;
          newValue.map((item) => {
            item.subtotal = (item.unitPrice * item.amount * 100) / 100;
            total += (item.subtotal * 100) / 100;
          });
          this.paymentInfo.orderTotal = total;
        }
      },
    },
    paymentInfo: {
      deep: true,
      handler(newValue) {
        let newNeedToPayAmount =
          (newValue.orderTotal * 100 +
            this.temporaryTotal * 100 +
            newValue.freight * 100 -
            newValue.discount * 100 -
            newValue.promotionPrice * 100 -
            newValue.couponPrice * 100) /
          100;
        if (newNeedToPayAmount <= 0) {
          this.paymentInfo.discount = 0;
          return false;
        }
        this.paymentInfo.needToPay =
          newNeedToPayAmount > 0 ? newNeedToPayAmount : 0;
      },
    },
    printerDialog: {
      handler(newVal) {
        if (newVal) {
          let date = new Date();
          this.nowDate = formaTimeToSecond(date.getTime());
          this.userRealName = getDBUserRealName()
            ? getDBUserRealName()
            : "暂无";
        }
      },
    },
  },
  methods: {
    viewVoucher() {
      this.showVoucher = true;
    },
    closeVoucher() {
      this.showVoucher = false;
    },
    // 切换到前一张凭证
    prevVoucher() {
      if (this.currVoucherIndex === 0) {
        // 如果当前凭证是第一张
        this.currVoucherIndex = this.maxVouncherIndex;
      } else {
        this.currVoucherIndex--;
      }
      this.$refs.carouselList.style.transform = `translate3d(-${
        this.currVoucherIndex * 770
      }px, 0, 0)`;
    },
    // 切换到后一张凭证
    nextVoucher() {
      if (this.currVoucherIndex === this.maxVouncherIndex) {
        // 如果当前凭证是最后一张
        this.currVoucherIndex = 0;
      } else {
        this.currVoucherIndex++;
      }
      this.$refs.carouselList.style.transform = `translate3d(-${
        this.currVoucherIndex * 770
      }px, 0, 0)`;
    },
    onShip() {
      this.showShipDialog = true;
    },
    cancelShip() {
      this.showShipDialog = false;
    },
    toShip() {
      let data = {
        orderCode: this.orderCode,
        expressId: this.selectedLogis,
        expressCode: this.waybillCode,
      };
      this._confirmShip(data);
    },
    reviewOutOfStore() {
      this.$confirm(`是否出库`, "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 出库
        let outStockGoodsList = [];
        this.orderDetail.map((good) => {
          if (!good.isTemp) {
            outStockGoodsList.push({
              id: good.id,
              warehouseId: good.selectedStoreId,
            });
          }
        });
        let data = {
          orderCode: this.orderCode,
          outStockGoodsList,
        };
        this._reviewOutOfStore(data);
      });
    },
    onUpdateAmount(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterAmountNum(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.orderDetail[this.updateCommodityIndex])
      );
      commodity.amount = val;
      this.orderDetail.splice(this.updateCommodityIndex, 1, commodity);
    },
    onUpdateUnitPrice(updateIndex) {
      this.updateCommodityIndex = updateIndex;
    },
    filterUnitPrice(val) {
      console.log(val);
      let commodity = JSON.parse(
        JSON.stringify(this.orderDetail[this.updateCommodityIndex])
      );
      commodity.unitPrice = val;

      this.orderDetail.splice(this.updateCommodityIndex, 1, commodity);
    },
    filterOrderTotal(val) {
      this.paymentInfo.orderTotal = val;
    },
    filterFreightNum(val) {
      this.paymentInfo.freight = val;
    },
    filterDiscountNum(val) {
      this.paymentInfo.discount = val;
    },
    filterCouponPriceNum(val) {
      this.paymentInfo.couponPrice = val;
    },
    filterPromotionPriceNum(val) {
      this.paymentInfo.promotionPrice = val;
    },
    toOrderList() {
      this.$router.push({
        path: "/supplier/spl-order/sample-from",
      });
    },
    //添加临时商品
    addTemporary() {
      let obj = {
        goodsName: "",
        itemTitle: "",
        quantity: 1,
        unitPrice: "",
      };
      this.temporaryData.push(obj);
    },
    //删除临时商品
    delTemporary(index) {
      this.temporaryData.splice(index, 1);
    },
    //删除表格里的临时商品
    delTableTemporary(index, id) {
      this.orderDetail.splice(index, 1);
      this.delTemporaryIds.push(id);
    },
    //修改临时商品数量
    onUpdateTemporary(updateIndex) {
      this.updateTemporaryIndex = updateIndex;
    },
    filterTemporary(val) {
      let commodity = JSON.parse(
        JSON.stringify(this.temporaryData[this.updateTemporaryIndex])
      );
      commodity.quantity = val;
      this.temporaryData.splice(this.updateTemporaryIndex, 1, commodity);
    },
    //修改临时商品价格
    filterTemporaryUnitPrice(event, index) {
      let commodity = JSON.parse(JSON.stringify(this.temporaryData[index]));
      commodity.unitPrice = event;
      this.temporaryData.splice(index, 1, commodity);
    },
    // 切换为编辑模式
    toUpdateOrder() {
      this._switchEditModule();
    },
    // 保存编辑
    updateOrder() {
      let orderDetail = [];
      let tempOrderDetailList = [];
      this.orderDetail.map((item) => {
        if (!item.isTemp) {
          orderDetail.push({
            id: item.id,
            unitPrice: item.unitPrice,
            quantity: item.amount,
          });
        } else {
          tempOrderDetailList.push({
            goodsName: item.commodityName,
            itemTitle: item.norm,
            unitPrice: item.unitPrice,
            quantity: item.amount,
          });
        }
      });
      //验证临时商品
      let temporaryStop = false;
      this.temporaryData.map((value) => {
        if (value.goodsName === "") {
          temporaryStop = true;
        } else if (value.itemTitle === "") {
          temporaryStop = true;
        } else if (value.unitPrice === "" || Number(value.unitPrice) === 0) {
          temporaryStop = true;
        }
      });
      if (temporaryStop) {
        this.$alert("请填入完整临时商品信息", "操作提示", {
          confirmButtonText: "确定",
        });
        return false;
      }
      tempOrderDetailList = tempOrderDetailList.concat(this.temporaryData);
      let order = {
        setMealId: this.setMealId,
        goodsTotalPrice: this.paymentInfo.orderTotal,
        orderCode: this.orderCode,
        freight: Number(this.paymentInfo.freight),
        discount: Number(this.paymentInfo.discount),
        couponDiscount: Number(this.paymentInfo.couponPrice),
        promotionReduce: Number(this.paymentInfo.promotionPrice),
        dbMessage: this.orderInfo.dbMessage,
      };
      let address = {
        receivedName: this.receiptInfo.receiver,
        receivedPhone: this.receiptInfo.telephone,
        province: this.receiptInfo.proCityDisIdArr[0],
        city: this.receiptInfo.proCityDisIdArr[1],
        regions: this.receiptInfo.proCityDisIdArr[2],
        address: this.receiptInfo.address,
      };
      let data = {
        orderDetail,
        order,
        address,
        tempOrderDetailList,
      };
      this._updateOrder(data);
    },
    cancelUpdate() {
      this._switchViewModule();
      // 重新获取详情--因为编辑过程可能修改了值
      let orderCode = this.$route.query.orderCode;
      this._getDBOrderDetailByCode(orderCode);
      this._switchViewModule();
      this.temporaryData = [];
    },
    _reviewOutOfStore(data) {
      dbOrder.reviewOutOfStore(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "审核通过",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 更新订单
    _updateOrder(data) {
      dbOrder.updateOrder(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this.temporaryData = [];
          this._getDBOrderDetailByCode(this.orderCode);
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
        // 切换为浏览模式
        this._switchViewModule();
      });
    },
    _getDBOrderDetailByCode(orderCode) {
      supplier.getSupplierSampleDetail(orderCode).then((res) => {
        console.log(res);
        if (res.success) {
          let {
            deliveryAddress,
            orderAddress,
            xbInfo,
            detailList,
            moduleStorage,
            expressRecord,
            payment,
            storageOutRecord,
            order,
            tempDetailList,
          } = res.result;
          this.setMealId = order.setMealId ? order.setMealId : 0;
          this.isMeal = order.setMealId ? true : false;
          // 当前仓库状态是否开启
          this.moduleStorage = moduleStorage;
          // 当前订单状态描述
          this.currOrderStatus = order.status;
          this.currOrderDesc = orderStatusToDesc(order.status);
          // 凭证列表
          this.voucherList = [];
          if (order.enclosure) {
            order.enclosure.map((item) => {
              this.voucherList.push(item);
            });
          }
          // 客户相关信息
          if (xbInfo) {
            this.customInfo.name = xbInfo.name;
            if (xbInfo.regionsValue) {
              this.customInfo.area = xbInfo.cityValue + xbInfo.regionsValue;
            } else {
              this.customInfo.area = xbInfo.cityValue;
            }
            this.customInfo.contact = xbInfo.contact;
            this.customInfo.telephone = xbInfo.telephone;
          }
          this.customInfo.payMethod = payment.paymentMethod;
          this.customInfo.payMethodDesc = payMethodMap[payment.paymentMethod];
          this.customInfo.payStatus = payment.paymentStatus;
          this.paymentInfo.message = payment.message;
          this.customInfo.message = order.xbMessage ? order.xbMessage : "无";
          // 订单详情--商品列表
          this.orderDetail = [];
          detailList.map((item) => {
            let normList = JSON.parse(item.itemTitle);
            let norm = "";
            for (let key in normList) {
              norm += `,${normList[key]}`;
            }
            let storeList = [];
            item.wareHouseAndNum.map((store) => {
              storeList.push({
                desc: `${store.name}(库存：${store.num})`,
                id: store.id,
              });
            });
            this.orderDetail.push({
              isTemp: false,
              id: item.id,
              code: item.goodsCode,
              commodityImg: item.goodsPic ? item.goodsPic : defaultGoodPic,
              commodityName: item.goodsName,
              norm: norm.substring(1),
              unitPrice: item.unitPrice,
              // 商品数量--即订购数
              amount: item.quantity,
              subtotal: item.subtotal,
              promotionReduce: item.promotionReduce,
              // 出货仓库列表
              storeList: storeList,
              // 选择的仓库
              selectedStoreId: storeList.length > 0 ? storeList[0].id : "",
              // 订购数
              numOfOrder: item.quantity,
              // 已出库数
              numOfOut: item.storageOutSum,
              // 本次出库数
              currNumOfOut: item.quantity,
            });
          });
          tempDetailList.map((item) => {
            this.orderDetail.push({
              isTemp: true,
              id: item.id,
              code: item.goodsCode,
              commodityImg: item.goodsPic ? item.goodsPic : defaultGoodPic,
              commodityName: item.goodsName,
              norm: item.itemTitle,
              unitPrice: item.unitPrice,
              // 商品数量--即订购数
              amount: item.quantity,
              subtotal: item.subtotal,
              promotionReduce: item.promotionReduce,
              // 订购数
              numOfOrder: item.quantity,
            });
          });
          // 订单详情--合计
          this.paymentInfo.orderTotal = order.totalPrice;
          this.paymentInfo.freight = order.freight;
          this.paymentInfo.promotionPrice = order.promotionReduce;
          this.paymentInfo.discount = payment.discount;
          this.paymentInfo.couponPrice = payment.couponDiscount;
          this.paymentInfo.needToPay = order.paymentPrice;
          // 订单详情--编号+时间+商家备注
          this.orderInfo.orderNum = order.orderCode;
          this.orderInfo.paymentNum = order.paymentCode
            ? order.paymentCode
            : null;
          this.orderInfo.createOrderTime = formaTimeToSecond(order.createTime);
          this.orderInfo.completePayTime = order.paymentTime
            ? formaTimeToSecond(order.paymentTime)
            : null;
          this.orderInfo.completeOrderTime = order.finishedTime
            ? formaTimeToSecond(order.finishedTime)
            : null;
          this.orderInfo.dbMessage = order.dbMessage;
          // 操作记录相关信息
          this.outStoreRecordList = [];
          if (storageOutRecord.length) {
            storageOutRecord.map((record) => {
              this.outStoreRecordList.push({
                // 出库单号
                outStoreCode: record.outStockCode,
                // 出库时间
                outStoreTime: formaTimeToSecond(record.outStockTime),
                // 出库仓库
                outStoreName: record.warehouseName,
              });
            });
          }
          if (expressRecord) {
            this.expressInfo.waybillCode = expressRecord.expressCode
              ? expressRecord.expressCode
              : "无";
            this.expressInfo.express = expressRecord.expressName
              ? expressRecord.expressName
              : "无";
          }
          // 编辑修改收货地址
          let {
            receivedName,
            receivedPhone,
            address,
            fullAddress,
            province = "",
            city = "",
            regions = "",
          } = orderAddress;
          this.receiptInfo.receiver = receivedName;
          this.receiptInfo.telephone = receivedPhone;
          this.receiptInfo.address = address;
          this.receiptInfo.fullAddress = fullAddress;
          this.receiptInfo.deliveryAddress = deliveryAddress;
          this.receiptInfo.addressInfo = `${this.receiptInfo.receiver}  ${this.receiptInfo.fullAddress}  ${this.receiptInfo.telephone}`
          if (!regions) {
            this.receiptInfo.proCityDisIdArr = [province, city];
          } else {
            this.receiptInfo.proCityDisIdArr = [province, city, regions];
          }
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        this.addressList = res;
      });
    },
    // 切换为浏览模式
    _switchViewModule() {
      this.pageModule = pageModules.viewModule;
    },
    // 切换为编辑模式
    _switchEditModule() {
      this.pageModule = pageModules.editModule;
    },
    // 发货确认
    _confirmShip(data) {
      dbOrder.confirmShip(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "发货成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getDBOrderDetailByCode(this.orderCode);
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
        this.showShipDialog = false;
      });
    },
    // 获取所有快递公司列表
    _getLogisList() {
      dbOrder.getLogisList().then((res) => {
        if (res.success) {
          this.logisList = [];
          res.result.map((item) => {
            this.logisList.push({
              id: item.id,
              expressName: item.expressName,
              expressApi: item.expressApi,
            });
          });
        }
      });
    },
    // 获取当前物流信息
    getLogisDetail(orderCode) {
      dbOrder.getDBLogisDetailByCode(orderCode).then((res) => {
        console.log(res);
        if (res.success) {
          if (res.result) {
            let arr = [];
            res.result.Traces.map((value) => {
              let obj = {};
              obj.remark = value.AcceptStation;
              obj.datetime = value.AcceptTime;
              arr.unshift(obj);
            });
            this.LogisDetail = arr;
          } else {
            this.LogisDetail = [];
          }
        }
      });
    },
    openPrinterDialog() {
      this.printerDialog = true;
    },
    closePrinterDialog() {
      this.printerDialog = false;
    },
  },
  created() {
    this.orderCode = this.$route.query.orderCode;
    if (this.$route.query.showShip) {
      this.infoType = infoTypes.shipmentInfo;
    }
    this._getDBOrderDetailByCode(this.orderCode);
    // 获取城市数据列表
    this._getDBAddressMock();
    // this.getLogisDetail(this.orderCode);
    // 获取物流列表
    this._getLogisList();
    // 当前域名
    this.domain = window.location.host;
    //是否可以添加临时商品
    this.moduleTempGoods = getSupplierBasicInformation().moduleTempGoods === 1;
  },
  mounted() {
    const paddingWidth = 68;
    this.$refs.operations.style.width =
      this.$refs.baseContent.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseContent.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    IntInput,
    DecimalInput,
  },
};
</script>

<style lang="scss" scoped>
.sample-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .radios-container {
    margin-top: 30px;
  }
  .order-information {
    padding: 20px 24px;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    color: rgba(96, 98, 102, 1);
    .customer-related {
      .top {
        display: flex;
        .left {
          width: 60%;
          .left-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 18px;
            .container {
              width: 50%;
              .desc {
                width: 76px;
                display: inline-block;
                text-align: right;
              }
            }
          }
        }
        .right {
          width: 40%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          .order-status {
            margin-left: 8px;
            color: royalblue;
          }
        }
      }
      .bottom {
        .desc {
          display: inline-block;
          width: 76px;
          text-align: right;
        }
      }
    }
    .order-detail-related {
      margin: 26px 0;
      .table-img {
        .table-container {
          .amount-input,
          .gray {
            width: 96px;
          }
          .scribing {
            text-decoration: line-through;
            margin-right: 10px;
          }
          .delete-btn {
            position: absolute;
            cursor: pointer;
            font-size: 12px;
            right: 10px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .subtotal {
        display: flex;
        padding: 12px 36px 12px 16px;
        border: 1px solid #eee;
        border-top: none;
        .detail {
          display: flex;
          align-items: center;
          flex: 1;
          .order-total,
          .order-freight,
          .order-discount,
          .order-couponPrice,
          .order-promotionPrice {
            margin-right: 30px;
          }
        }
        .amounts-payable {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .subtotal-edit {
        display: flex;
        padding: 12px 36px 12px 16px;
        border: 1px solid #eee;
        border-top: none;
        .detail {
          width: 50%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .desc {
            width: 85px;
            text-align: right;
          }
          .order-total {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .orderTotal-input {
              width: 85px;
            }
          }
          .order-freight {
            margin-left: 8px;
            margin-right: 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .freight-input {
              width: 80px;
            }
          }
          .order-discount {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .discount-input {
              width: 80px;
            }
          }
        }
        .amounts-payable {
          width: 50%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .gray {
            width: 96px;
          }
        }
      }
      .temporary-container {
        border-right: 1px solid #eee;
        border-left: 1px solid #eee;
        .temporary-item {
          height: 56px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #eee;
          .temporary-name {
            width: 400px;
            box-sizing: border-box;
            padding: 0 16px;
            .el-input {
              width: 100%;
            }
          }
          .temporary-spec {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .temporary-price {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            .discount-input {
              width: 96px;
            }
          }
          .temporary-num {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            .good-amount {
              width: 96px;
            }
          }
          .temporary-total {
            flex: 1;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
          }
          .el-input {
            width: 96px;
          }
          .delete-btn {
            position: absolute;
            cursor: pointer;
            font-size: 12px;
            right: 10px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .add-commodity-btn {
        width: 100%;
        height: 32px;
        line-height: 20px;
        padding: 6px 0 6px 16px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
        border: 1px solid #eee;
        border-top: none;
        .add-btn {
          cursor: pointer;
        }
      }
    }
    .pay-detail-related {
      padding-bottom: 20px;
      .container {
        margin-bottom: 18px;
        .desc {
          min-width: 100px;
          display: inline-block;
          text-align: right;
        }
      }
      .container-remark {
        display: flex;
        .textarea {
          width: 320px;
        }
      }
      .offline-payment-info {
        box-sizing: border-box;
        width: 100%;
        margin-top: 10px;
        font-size: 14px;
        line-height: 20px;
        padding-left: 16px;
        .container {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .btn-desc {
            display: inline-block;
            width: 80px;
            text-align: right;
          }
          .btn {
            color: rgba(61, 116, 242, 0.75);
            cursor: pointer;
            &:hover {
              color: rgba(61, 116, 242, 1);
            }
          }
        }
        .view-remark {
          margin-top: 18px;
          .remark {
            width: 80px;
            height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }
  .fullAddress {
    margin-top: 18px;
  }
  .shipment-info {
    display: flex;
    padding: 20px 24px;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    font-size: 14px;
    color: #666;
    .shipment-info-preview {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .order-info {
        height: 90px;
        background: rgba(251, 252, 253, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        border-radius: 0px 4px 4px 4px;
        font-size: 14px;
        color: #666666;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .code-status {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .code {
            margin-right: 120px;
            .desc {
              text-align: right;
              display: inline-block;
              width: 120px;
            }
          }
        }
        .receiver {
          .desc {
            text-align: right;
            display: inline-block;
            width: 120px;
          }
        }
      }
      .good-list {
        margin-top: 40px;
        .top {
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 16px;
            color: #666;
          }
        }
      }
      .operation-record {
        margin-top: 20px;
        .title {
          font-size: 16px;
          color: #666;
          margin-bottom: 16px;
        }
        .record-detail {
          min-height: 110px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding-left: 22px;
          border: 1px solid rgba(229, 229, 229, 1);
          border-radius: 0px 4px 4px 4px;
          font-size: 14px;
          color: #666;
          .record-info {
            margin-bottom: 10px;
            .row {
              line-height: 24px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
            .item {
              margin-right: 34px;
            }
          }
          .express-info {
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .item {
              margin-right: 34px;
            }
          }
        }
        .record-empty-tip {
          width: 100%;
          min-height: 110px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #e3e3e3;
        }
      }
    }
    .logistic-edit {
      padding: 20px 24px;
      border-radius: 0px 4px 4px 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      font-size: 14px;
      font-weight: 400;
      color: rgba(96, 98, 102, 1);
      .title {
        font-size: 16px;
        font-weight: 550;
        color: #606266;
        letter-spacing: 2px;
      }
      .container {
        display: flex;
        margin-top: 12px;
        margin-bottom: 26px;
        .desc {
          width: 80px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .gray {
          width: 250px;
        }
        .special {
          width: 480px;
        }
      }
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
    .btns {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .printer {
        width: 48px;
        padding: 0;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .btns-edit {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .to-ship-container {
    .title {
      font-size: 14px;
      color: #666666;
      font-weight: 550;
    }
    .content {
      box-sizing: border-box;
      border-top: 1px solid #ccc;
      padding-top: 24px;
      width: 100%;
      .container {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0px;
        }
        .label {
          width: 80px;
          text-align: right;
          margin-right: 6px;
        }
        .gray {
          width: 310px;
        }
      }
    }
    .btns {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 24px;
      }
    }
  }
  .cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(96, 98, 102, 0.5);
    z-index: 1;
    .close-btn-container {
      padding-top: 48px;
      padding-right: 48px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .close-btn {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 2px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        color: #fff;
        cursor: pointer;
      }
    }
    .carousel-container {
      box-sizing: border-box;
      width: 100vw;
      position: relative;
      display: flex;
      justify-content: center;
      .viewport {
        width: 770px;
        height: 500px;
        overflow: hidden;
        position: relative;
        .carousel-list {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: absolute;
          top: 0;
          .carousel-item {
            flex-shrink: 0;
            width: 770px;
            height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
            .voucher-img {
              max-height: 100%;
              max-width: 100%;
            }
          }
          .one {
            background: salmon;
          }
          .two {
            background: #df3445;
          }
          .three {
            background: #3d74f2;
          }
        }
      }
      .prev-btn {
        position: absolute;
        top: 250px;
        left: 20px;
        width: 16px;
        height: 16px;
        border-top: 4px solid #fff;
        border-right: 4px solid #fff;
        transform: rotate(225deg);
        cursor: pointer;
      }
      .next-btn {
        position: absolute;
        top: 250px;
        right: 40px;
        width: 16px;
        height: 16px;
        border-top: 4px solid #fff;
        border-right: 4px solid #fff;
        transform: rotate(45deg);
        cursor: pointer;
      }
    }
    .tip {
      width: 100vw;
      display: flex;
      justify-content: center;
      font-size: 16px;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
#sampleDetail {
  .table-img {
    .el-table {
      .el-table__body-wrapper {
        .el-table__body {
          tbody {
            tr {
              td {
                .cell {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .name {
                    color: #606266;
                    white-space:nowrap
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .to-ship-container {
    padding-left: 16px;
    padding-right: 16px;
    .el-dialog__header {
      padding: 12px 24px;
      line-height: 24px;
      font-size: 16px;
      color: #606266;
      .el-dialog__headerbtn {
        top: 13px;
      }
    }
    .el-dialog__body {
      padding: 0;
      .border {
        margin: 0 24px;
      }
      .logistics-info {
        height: 319px;
        padding: 0 24px;
        overflow: auto;
        .desces {
          padding: 8px 0px;
          display: flex;
          align-items: center;
          height: 24px;
          .desc-item {
            &:first-child {
              margin-right: 24px;
            }
            line-height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            white-space: nowrap;
          }
        }
        .list {
          padding-left: 14px;
          padding-bottom: 20px;
          li {
            border-left: 1px solid #f7f7f7;
            padding-left: 23px;
            position: relative;
            color: #919398;
            i {
              position: absolute;
              display: inline-block;
              left: -5px;
              width: 9px;
              height: 9px;
              border-radius: 50%;
              background: #c0c4cc;
            }
            .space {
              font-size: 12px;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .time {
              font-size: 12px;
              line-height: 17px;
              padding-bottom: 5px;
              border-bottom: 1px solid #f7f7f7;
            }
          }
        }
        .list li:nth-child(1) {
          i {
            position: absolute;
            display: inline-block;
            left: -8px;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #3d74f2;
          }
        }
      }
    }
  }
  .el-cascader {
    width: 252px;
    line-height: 32px;
    .el-input {
      line-height: 32px;
      .el-input__inner {
        height: 32px;
        background: rgba(234, 238, 245, 0.2);
        border: 1px solid #eaeef5;
      }
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
    }
  }
  .express-dialog {
    .el-dialog {
      height: 400px;
      font-family: "PingFangSC-Regular";
      .el-dialog__header {
        padding: 12px 24px;
        line-height: 24px;
        font-size: 16px;
        color: #606266;
        .el-dialog__headerbtn {
          top: 13px;
        }
      }
      .el-dialog__body {
        padding: 0;
        .border {
          margin: 0 24px;
        }
        .container {
          height: 319px;
          overflow: auto;
          padding: 0 24px;
          .express {
            padding: 8px 0px;
            display: flex;
            .express-p {
              line-height: 24px;
              height: 24px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(96, 98, 102, 1);
              line-height: 24px;
              letter-spacing: 1px;
              margin-right: 24px;
            }
          }
          .list {
            padding-left: 14px;
            padding-bottom: 20px;
            li {
              border-left: 1px solid #f7f7f7;
              padding-left: 23px;
              position: relative;
              color: #919398;
              i {
                position: absolute;
                display: inline-block;
                left: -5px;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: #c0c4cc;
              }
              .space {
                font-size: 12px;
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
              .time {
                font-size: 12px;
                line-height: 17px;
                padding-bottom: 5px;
                border-bottom: 1px solid #f7f7f7;
              }
            }
          }
          .list li:nth-child(1) {
            i {
              position: absolute;
              display: inline-block;
              left: -8px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #3d74f2;
            }
          }
        }
        .nothing {
          height: 319px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
  }
  .printer-dialog {
    .el-dialog__body {
      max-height: 80vh;
      overflow: auto;
      /* .printer {
        .printer-title {
          height: 64px;
          font-size: 32px;
          line-height: 64px;
          text-align: center;
        }
        .printer-message {
          display: flex;
          justify-content: space-between;
          .list {
            .list-item {
              font-size: 14px;
              padding-bottom: 16px;
            }
          }
          .list-right {
            width: 250px;
          }
        }
        .table {
          .price {
            display: flex;
            height: 32px;
            justify-content: space-between;
            align-items: center;
            border: 1px #f2f6fc solid;
            border-top: 0;
            .price-left {
              display: flex;
              p {
                margin: 0 16px;
              }
            }
            .price-right {
              display: flex;
              p {
                margin-right: 16px;
              }
            }
          }
          .remark {
            display: flex;
            height: 32px;
            border: 1px #f2f6fc solid;
            line-height: 32px;
            border-top: 0;
            .remark-title {
              width: 100px;
              border-right: 1px #f2f6fc solid;
              text-align: center;
            }
          }
        }
        .printer-option-message {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 32px;
        }
      } */
      .footer {
        height: 64px;
        box-sizing: border-box;
        padding-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
<style midia="print">
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
}
#printer .printer-message {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
}
#printer .printer-message .list .list-right {
  width: 250px;
}
#printer .table .price {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  border: 1px #000 solid;
  border-top: 0;
}
#printer .table .el-table {
  border: 1px solid #000;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .table .price .price-left {
  display: flex;
}
#printer .table .price .price-left p {
  margin: 0 16px;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table .price .price-right {
  display: flex;
}
#printer .table .price .price-right p {
  margin-right: 16px;
}
#printer .table th {
  width: 60px;
}
#printer .remark {
  display: flex;
  height: 32px;
  font-size: 12px;
  border: 1px #000 solid;
  line-height: 32px;
  border-top: 0;
}
#printer .remark .remark-title {
  width: 100px;
  border-right: 1px #000 solid;
  text-align: center;
}
#printer .remark .remark-content {
  padding-left: 10px;
}
#printer .printer-option-message {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  font-size: 12px;
}
#printer .printer-logistics {
  margin-top: 30px;
  border: 1px solid rgba(96, 98, 102, 1);
  border-bottom: 0;
  border-radius: 8px 8px 0px 0px;
}
#printer .printer-logistics .logistics-list {
  display: flex;
  min-height: 30px;
  border-bottom: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item:first-child {
  border-right: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item {
  flex: 1;
  min-height: 30px;
  line-height: 30px;
  padding-left: 16px;
}
#printer .printer-logistics .logistics-list .logistics-item.border0 {
  border-right: 0;
}
</style>